import React, { useRef } from "react";
import {
  TariffCardContainer,
  TariffInfoContainer,
  TariffExpiration,
  TariffTitle,
  TariffDescription,
  TariffPriceContainer,
  TariffPrice,
  PricePeriod,
  PriceButtonContainer,
} from "./TariffCard.styles";
import Button from "../Buttons/Button";
import { TariffCardProps } from "./TariffCard.types";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";

const TariffCard: React.FC<TariffCardProps> = ({
  title,
  description,
  price,
  isActive,
  expirationDate,
  tariffId,
  onChangeTariff,
  by_request
}) => {
  const toastRef = useRef<Toast>(null);
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (isActive) {
      navigate(`/subscriptions/${tariffId}`);
    } else {
      onChangeTariff(tariffId);
    }
  };

  const buttonVariant = isActive ? "pink" : "default";

  return (
    <>
      <Toast ref={toastRef} />
      <TariffCardContainer>
        <TariffInfoContainer>
          <TariffExpiration>
            {expirationDate ? `действует до ${expirationDate}` : "Недоступно"}
          </TariffExpiration>
          <TariffTitle>{title}</TariffTitle>
          <TariffDescription>{description}</TariffDescription>
        </TariffInfoContainer>
        <PriceButtonContainer>
        <TariffPriceContainer>
          <TariffPrice>₽ {price}</TariffPrice>
          <PricePeriod>/мес</PricePeriod>
        </TariffPriceContainer>
        <Button
          variant={buttonVariant}
          onClick={handleButtonClick}
          disabled={by_request}
        >
          {isActive ? "Управлять" : "Подключить тариф"}
        </Button>
        </PriceButtonContainer>
      </TariffCardContainer>
    </>
  );
};

export default TariffCard;
